// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","vUiHueDark":"#ccc","vUiHue":"#ddd","vPopover":"5000","list":"WithAutoComplete__list___4-myA"};